import type { Guide } from '../types';

/** Address, name, search title and description of the guide in each language (menus, cards, links). */
export const thingsToDoGuide: Guide = {
  id: 'o-que-fazer',
  imageTour: 'lancha-privada-madame',
  published: '2026-10-23',
  updated: '2026-10-23',
  tours: [
    'Passeio-em-aquamarina-ll',
    'saco-de-mamangua-lancha-rapida',
    'jeep-mata-atlantica',
    'jeep-mata-atlantica-15823',
  ],
  copy: {
    pt: {
      slug: 'o-que-fazer-em-paraty',
      label: 'O que fazer em Paraty',
      title: 'O Que Fazer em Paraty: 10 Passeios Imperdíveis',
      description: 'O que fazer em Paraty: passeio de escuna pelas ilhas, Saco do Mamanguá, Trindade, cachoeiras de jeep, alambiques, mergulho e o Centro Histórico. Com roteiro de 3 dias e dicas de quem vive aqui.',
    },
    es: {
      slug: 'que-hacer-en-paraty',
      label: 'Qué hacer en Paraty',
      title: 'Qué Hacer en Paraty: 10 Paseos Imperdibles',
      description: 'Qué hacer en Paraty: paseo en barco por las islas, Saco do Mamanguá, Trindade, cascadas en jeep, alambiques, buceo y el Centro Histórico. Con itinerario de 3 días y consejos de quien vive aquí.',
    },
    en: {
      slug: 'things-to-do-in-paraty',
      label: 'Things to do in Paraty',
      title: 'Things to Do in Paraty: 10 Tours You Should Not Miss',
      description: 'Things to do in Paraty: schooner tour of the islands, Saco do Mamanguá, Trindade, waterfalls by jeep, cachaça distilleries, diving and the Historic Center. With a 3-day itinerary and local tips.',
    },
    fr: {
      slug: 'que-faire-a-paraty',
      label: 'Que faire à Paraty',
      title: 'Que Faire à Paraty : 10 Excursions Incontournables',
      description: 'Que faire à Paraty : excursion en goélette dans les îles, Saco do Mamanguá, Trindade, cascades en jeep, distilleries de cachaça, plongée et centre historique. Avec un itinéraire de 3 jours et des conseils locaux.',
    },
  },
};
